/* eslint-disable no-console */
import { mapState, mapActions, mapGetters } from 'vuex'
import * as Sentry from '@sentry/vue'
import Socket from '@/socket'
import SlideOptionApi from '@/api/slideOption'
import EventBus from '@/eventBus'
import Utils from '@/util'
import SpinnerWheelConfig from '@/constant/SpinnerWheelConfig'

export default {
  data() {
    return {
      newEntry: '',
      submitting: false,
    }
  },
  computed: {
    ...mapGetters(['isBackstage', 'isPresenting']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
      sharePresentation: (state) => state.sharePresentation,
    }),
    entriesPlaceholder() {
      return this.isInputExpanded
        ? this.$t('multipleEntriesPlaceholder')
        : this.$t('entriesPlaceholder')
    },
    isInputExpanded() {
      return this.newEntry
        || (this.slideActive && this.slideActive.isFocusingInput)
    },
    isAddButtonDisabled() {
      return !this.newEntry
        || this.submitting
        || this.isBackstage
        || this.sharePresentation
        || this.isReachedMaxLength
    },
    rawEntries() {
      return this.newEntry
        .split(/\r?\n/)
        .filter((item) => item.trim())
    },
    isReachedMaxLength() {
      return this.countWheelEntries + this.rawEntries.length > SpinnerWheelConfig.SPINNER_WHEEL_LIMIT
    },
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    onFocusEntryInput() {
      if (this.isShowInputEditor) {
        this._updateSlideActiveFocusingInput(true)
      }
    },
    onBlurEntryInput() {
      this._updateSlideActiveFocusingInput(false)
    },
    _updateSlideActiveFocusingInput(boolean) {
      this.updateSlideActiveAction({
        isFocusingInput: boolean,
      })
    },
    _preparePayload() {
      let order = 0

      if (this.slideActive.SlideOptions && this.slideActive.SlideOptions.length) {
        order = this.slideActive.SlideOptions.slice(-1)[0].order
      }

      const options = this.rawEntries
        .map((entry) => ({
          accessCode: this.presentation.uniqueAccessCode,
          presentationId: this.presentation.id,
          order: ++order,
          slideId: this.slideActive.id,
          socketId: Socket.getSocketId(),
          title: entry.trim(),
        }))

      return {
        accessCode: this.presentation.uniqueAccessCode,
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
        socketId: Socket.getSocketId(),
        options,
      }
    },
    async _requestCreateEntries(payload) {
      this.submitting = true

      try {
        const {
          SlideOptions: slideOptions,
        } = await SlideOptionApi.createSpinnerWheelOptions(payload)
        this.newEntry = ''

        this.$store.state.slideActive.SlideOptions.push(...slideOptions)
        this.updateSlideActiveAction({
          SlideOptions: this.slideActive.SlideOptions,
        })
        EventBus.$emit('createEntries', slideOptions)
      } catch (e) {
        Sentry.captureException(e)
        this.$store.dispatch('setSyncPresentation', 3)
        if (e.body && e.body.message) {
          Utils.showToastError(e.body.message)
        }
      } finally {
        this.submitting = false
      }
    },
    async submitNewEntries() {
      if (this.slideActive.wheelStatus === 'spinning') return
      if (!this.newEntry || this.submitting) return

      const payload = this._preparePayload()

      await this._requestCreateEntries(payload)
    },
  },
}
